import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const restaurantOrderApi = {
  claimNextPrintJob: ({ signal } = {}) =>
    axiosClient
      .post(ENDPOINTS.restaurantPrintJobs.claimNext, null, {
        signal,
        skipGlobalErrorRedirect: true,
        validateStatus: (status) => status === 204 || (status >= 200 && status < 300),
      })
      .then(unwrap),

  markPrintJobPrinted: (jobId, claimToken, { signal } = {}) =>
    axiosClient
      .post(ENDPOINTS.restaurantPrintJobs.printed(jobId), { claimToken }, {
        signal,
        skipGlobalErrorRedirect: true,
      })
      .then(unwrap),

  markPrintJobFailed: (jobId, claimToken, error, { signal } = {}) =>
    axiosClient
      .post(ENDPOINTS.restaurantPrintJobs.failed(jobId), { claimToken, error }, {
        signal,
        skipGlobalErrorRedirect: true,
      })
      .then(unwrap),

  list: ({ page = 0, size = 3, fromDate, toDate, search } = {}) => {
    const params = { page, size };
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (search?.trim()) params.search = search.trim();
    return axiosClient
      .get(ENDPOINTS.restaurantOrders.list, { params })
      .then(unwrap);
  },

  retryPrintJob: (jobId) =>
    axiosClient
      .post(ENDPOINTS.restaurantPrintJobs.retry(jobId))
      .then(unwrap),

  reprintDocument: (documentType, documentId) =>
    axiosClient
      .post(ENDPOINTS.restaurantPrintJobs.reprint(documentType, documentId))
      .then(unwrap),

  detail: (restaurantOrderId) =>
    axiosClient
      .get(ENDPOINTS.restaurantOrders.detail(restaurantOrderId))
      .then(unwrap),

  history: (restaurantOrderId) =>
    axiosClient
      .get(ENDPOINTS.restaurantOrders.history(restaurantOrderId))
      .then(unwrap),
};
